import { render, staticRenderFns } from "./EncounterStatistics.vue?vue&type=template&id=c3e798f6&scoped=true&"
import script from "./EncounterStatistics.vue?vue&type=script&lang=js&"
export * from "./EncounterStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EncounterStatistics.vue?vue&type=style&index=0&id=c3e798f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e798f6",
  null
  
)

export default component.exports